// extracted by mini-css-extract-plugin
export var bounce = "_l1-1";
export var generatingText = "_l1-6";
export var lightning = "_l1-4";
export var popup = "_l1-5";
export var progressBar = "_l1-7";
export var progressFill = "_l1-8";
export var progressShimmer = "_l1-9";
export var progressText = "_l1-a";
export var shimmer = "_l1-3";
export var uploadIcon = "_l1-0";
export var uploadingText = "_l1-2";